/**
 * Korean profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Korean
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 239
 */

export const KO = {
  "metadata": {
    "name": "Korean",
    "code": "ko",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 239
  },
  "words": [
    {
      "word": "바보",
      "severity": 1,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "바보",
        "babo",
        "babbo"
      ],
      "case_sensitive": false,
      "context_notes": "Mild insult meaning 'fool' or 'stupid', commonly used even affectionately",
      "target_type": "individual"
    },
    {
      "word": "똥",
      "severity": 1,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "똥",
        "ttong",
        "ddong"
      ],
      "case_sensitive": false,
      "context_notes": "Basic scatological reference meaning 'poop', mild profanity",
      "target_type": "general"
    },
    {
      "word": "시발",
      "severity": 3,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "시발",
        "씨발",
        "sibal",
        "shibal",
        "ㅅㅂ",
        "시1발"
      ],
      "case_sensitive": false,
      "context_notes": "Strong curse word, literally 'pussy', most common Korean swear word",
      "target_type": "general"
    },
    {
      "word": "씨발",
      "severity": 3,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "씨발",
        "시발",
        "ssibal",
        "shibal",
        "ㅅㅂ"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of sibal, extremely common Korean expletive",
      "target_type": "general"
    },
    {
      "word": "개새끼",
      "severity": 3,
      "categories": [
        "insult",
        "family_honor"
      ],
      "variations": [
        "개새끼",
        "gaesaekki",
        "개색",
        "ㄱㅅㄲ"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'puppy' but means 'son of a bitch', attacks family honor",
      "target_type": "individual"
    },
    {
      "word": "죽어",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "죽어",
        "jugeo",
        "jukeo",
        "죽어라"
      ],
      "case_sensitive": false,
      "context_notes": "Death command meaning 'die', extremely serious threat",
      "target_type": "individual"
    },
    {
      "word": "니 엄마",
      "severity": 4,
      "categories": [
        "family_honor",
        "insult"
      ],
      "variations": [
        "니 엄마",
        "ni eomma",
        "네 엄마",
        "ne eomma"
      ],
      "case_sensitive": false,
      "context_notes": "Attack on mother, violates fundamental Korean filial piety",
      "target_type": "family"
    },
    {
      "word": "병신",
      "severity": 3,
      "categories": [
        "insult",
        "hate_speech"
      ],
      "variations": [
        "병신",
        "byeongsin",
        "ㅂㅅ",
        "병1신"
      ],
      "case_sensitive": false,
      "context_notes": "Ableist slur meaning 'disabled person', highly offensive",
      "target_type": "individual"
    },
    {
      "word": "꼴통",
      "severity": 2,
      "categories": [
        "insult",
        "generational"
      ],
      "variations": [
        "꼴통",
        "kkoltong",
        "골통"
      ],
      "case_sensitive": false,
      "context_notes": "Political insult meaning 'stubborn conservative', generational conflict term",
      "target_type": "individual"
    },
    {
      "word": "꼰대",
      "severity": 2,
      "categories": [
        "generational",
        "insult"
      ],
      "variations": [
        "꼰대",
        "kkondae",
        "콘대"
      ],
      "case_sensitive": false,
      "context_notes": "Older person who forces outdated values, generational criticism",
      "target_type": "individual"
    },
    {
      "word": "좆",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "좆",
        "jot",
        "좇",
        "ㅈ"
      ],
      "case_sensitive": false,
      "context_notes": "Male genitalia reference, strong profanity often used for emphasis",
      "target_type": "general"
    },
    {
      "word": "미친",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "미친",
        "michin",
        "michi",
        "ㅁㅊ"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'crazy', moderate insult commonly used",
      "target_type": "individual"
    },
    {
      "word": "지랄",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "지랄",
        "jiral",
        "지럴",
        "ㅈㄹ"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'nonsense' or 'bullshit', moderate profanity",
      "target_type": "general"
    },
    {
      "word": "조센진",
      "severity": 4,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "조센진",
        "josenjin",
        "조선징"
      ],
      "case_sensitive": false,
      "context_notes": "Japanese colonial era slur for Koreans, extremely offensive historical term",
      "target_type": "group"
    },
    {
      "word": "된장녀",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "된장녀",
        "doenjangnyeo",
        "된장"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for women who prefer foreign brands, misogynistic",
      "target_type": "group"
    },
    {
      "word": "김치녀",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "김치녀",
        "gimchinyeo",
        "김치"
      ],
      "case_sensitive": false,
      "context_notes": "Anti-feminist slur targeting Korean women, highly misogynistic",
      "target_type": "group"
    },
    {
      "word": "한남",
      "severity": 2,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "한남",
        "hannam",
        "한국남자"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for Korean men, used in gender conflicts",
      "target_type": "group"
    },
    {
      "word": "창년",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "창년",
        "changnyeon",
        "창녀"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory term for women, means 'whore'",
      "target_type": "individual"
    },
    {
      "word": "좆같은",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "좆같은",
        "jotgateun",
        "좇같은",
        "ㅈ같은"
      ],
      "case_sensitive": false,
      "context_notes": "Strong profanity meaning 'fucking' or 'damn', very crude",
      "target_type": "general"
    },
    {
      "word": "개소리",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "개소리",
        "gaesori",
        "개솔",
        "ㄱㅅ"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'dog sound', means 'nonsense' or 'bullshit'",
      "target_type": "general"
    },
    {
      "word": "개놈",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "개놈",
        "gaenom",
        "개년"
      ],
      "context_notes": "Calling someone a 'dog', moderate insult",
      "target_type": "individual"
    },
    {
      "word": "젓같은",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "젓같은",
        "jeotgateun",
        "젖같은"
      ],
      "case_sensitive": false,
      "context_notes": "Mild profanity, softer alternative to stronger curses",
      "target_type": "general"
    },
    {
      "word": "엿먹어",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "엿먹어",
        "yeotmeogeo",
        "엿"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'eat taffy' but sexual connotation, means 'fuck off'",
      "target_type": "individual"
    },
    {
      "word": "꺼져",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "꺼져",
        "kkeojyeo",
        "꺼지라"
      ],
      "case_sensitive": false,
      "context_notes": "Command meaning 'get lost' or 'go away', rude dismissal",
      "target_type": "individual"
    },
    {
      "word": "닥쳐",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "닥쳐",
        "dakchyeo",
        "닥치라"
      ],
      "case_sensitive": false,
      "context_notes": "Command meaning 'shut up', rude and dismissive",
      "target_type": "individual"
    },
    {
      "word": "상놈",
      "severity": 3,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "상놈",
        "sangnom"
      ],
      "case_sensitive": false,
      "context_notes": "Historical class-based insult meaning 'commoner', status attack",
      "target_type": "individual"
    },
    {
      "word": "천민",
      "severity": 4,
      "categories": [
        "hate_speech",
        "class"
      ],
      "variations": [
        "천민",
        "cheonmin"
      ],
      "case_sensitive": false,
      "context_notes": "Historical lowest class reference, extremely classist and offensive",
      "target_type": "individual"
    },
    {
      "word": "쪽발이",
      "severity": 4,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "쪽발이",
        "jjokbari",
        "쪽바리"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory term for Japanese people, references foot-binding",
      "target_type": "group"
    },
    {
      "word": "짱깨",
      "severity": 4,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "짱깨",
        "jjangkkae",
        "짱개"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory term for Chinese people, highly racist",
      "target_type": "group"
    },
    {
      "word": "양놈",
      "severity": 3,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "양놈",
        "yangnom"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for Westerners, means 'foreign bastard'",
      "target_type": "group"
    },
    {
      "word": "흑형",
      "severity": 3,
      "categories": [
        "hate_speech",
        "racial"
      ],
      "variations": [
        "흑형",
        "heukhyeong"
      ],
      "case_sensitive": false,
      "context_notes": "Patronizing term for Black people, seemingly friendly but racially inappropriate",
      "target_type": "group"
    },
    {
      "word": "빨갱이",
      "severity": 3,
      "categories": [
        "hate_speech",
        "political"
      ],
      "variations": [
        "빨갱이",
        "ppalgaengi",
        "빨간"
      ],
      "case_sensitive": false,
      "context_notes": "Anti-communist slur meaning 'red', Cold War era hate speech",
      "target_type": "group"
    },
    {
      "word": "좌빨",
      "severity": 2,
      "categories": [
        "hate_speech",
        "political"
      ],
      "variations": [
        "좌빨",
        "jwappe",
        "좌파빨갱이"
      ],
      "case_sensitive": false,
      "context_notes": "Left-wing communist, political slur used by conservatives",
      "target_type": "group"
    },
    {
      "word": "종북",
      "severity": 3,
      "categories": [
        "hate_speech",
        "political"
      ],
      "variations": [
        "종북",
        "jongbuk",
        "종북주의자"
      ],
      "case_sensitive": false,
      "context_notes": "North Korea follower, serious political accusation in South Korea",
      "target_type": "individual"
    },
    {
      "word": "급식충",
      "severity": 2,
      "categories": [
        "generational",
        "insult"
      ],
      "variations": [
        "급식충",
        "geupsikchhung",
        "급식"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for young students, generational conflict language",
      "target_type": "group"
    },
    {
      "word": "틀딱",
      "severity": 2,
      "categories": [
        "generational",
        "insult"
      ],
      "variations": [
        "틀딱",
        "teulddak"
      ],
      "case_sensitive": false,
      "context_notes": "Mocking term for older people using technology poorly",
      "target_type": "group"
    },
    {
      "word": "노잼",
      "severity": 1,
      "categories": [
        "internet_gaming",
        "general"
      ],
      "variations": [
        "노잼",
        "nojaem",
        "no재미"
      ],
      "case_sensitive": false,
      "context_notes": "Internet slang meaning 'not fun' or 'boring', mild criticism",
      "target_type": "general"
    },
    {
      "word": "솔까말",
      "severity": 1,
      "categories": [
        "internet_gaming",
        "general"
      ],
      "variations": [
        "솔까말",
        "solkkamal",
        "솔직히까놓고말해서"
      ],
      "case_sensitive": false,
      "context_notes": "Internet abbreviation for 'honestly speaking', not really profane",
      "target_type": "general"
    },
    {
      "word": "ㅈㄴ",
      "severity": 3,
      "categories": [
        "internet_gaming",
        "sexual"
      ],
      "variations": [
        "ㅈㄴ",
        "jn",
        "존나"
      ],
      "case_sensitive": false,
      "context_notes": "Abbreviated form of 'jonna' (fucking), very common online",
      "target_type": "general"
    },
    {
      "word": "존나",
      "severity": 3,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "존나",
        "jonna",
        "ㅈㄴ",
        "조낸"
      ],
      "case_sensitive": false,
      "context_notes": "Intensifier meaning 'fucking' or 'very', extremely common",
      "target_type": "general"
    },
    {
      "word": "개빡침",
      "severity": 2,
      "categories": [
        "general",
        "internet_gaming"
      ],
      "variations": [
        "개빡침",
        "gaeppakchim",
        "개빡",
        "빡침"
      ],
      "case_sensitive": false,
      "context_notes": "Intense anger expression, common in gaming and online",
      "target_type": "general"
    },
    {
      "word": "멍청이",
      "severity": 1,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "멍청이",
        "meongcheongi",
        "멍청"
      ],
      "case_sensitive": false,
      "context_notes": "Mild insult meaning 'idiot' or 'stupid person'",
      "target_type": "individual"
    },
    {
      "word": "놈",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "놈",
        "nom"
      ],
      "case_sensitive": false,
      "context_notes": "Casual way to refer to a person, can be mildly derogatory",
      "target_type": "individual"
    },
    {
      "word": "새끼",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "새끼",
        "saekki",
        "색",
        "ㅅㄲ"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'baby animal', used as insult meaning 'bastard'",
      "target_type": "individual"
    },
    {
      "word": "자지",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "자지",
        "jaji",
        "ㅈㅈ"
      ],
      "case_sensitive": false,
      "context_notes": "Male genitalia, crude sexual reference",
      "target_type": "general"
    },
    {
      "word": "보지",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "보지",
        "boji",
        "ㅂㅈ"
      ],
      "case_sensitive": false,
      "context_notes": "Female genitalia, crude sexual reference",
      "target_type": "general"
    },
    {
      "word": "아가리",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "아가리",
        "agari"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 아가리, Romanization: agari - vulgar term for mouth, 'trap'",
      "target_type": "general"
    },
    {
      "word": "아씨",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "아씨",
        "aish",
        "아이씨"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 아씨, Romanization: aish - mild curse, 'ah fuck'",
      "target_type": "general"
    },
    {
      "word": "암캐",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "암캐",
        "amkae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 암캐, Romanization: amkae - female dog, derogatory for women",
      "target_type": "group"
    },
    {
      "word": "애자",
      "severity": 3,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "애자",
        "aeja"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 애자, Romanization: aeja - disabled person (offensive)",
      "target_type": "individual"
    },
    {
      "word": "빡치다",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "빡치다",
        "ppakchida",
        "빡쳐"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 빡치다, Romanization: ppakchida - to be pissed off",
      "target_type": "general"
    },
    {
      "word": "빡대가리",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "빡대가리",
        "ppakdaegari"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 빡대가리, Romanization: ppakdaegari - stubborn person, 'thick skull'",
      "target_type": "individual"
    },
    {
      "word": "빙신",
      "severity": 3,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "빙신",
        "bingsin"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 빙신, Romanization: bingsin - variant of byeongsin, ableist slur",
      "target_type": "individual"
    },
    {
      "word": "변태",
      "severity": 2,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "변태",
        "byeontae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 변태, Romanization: byeontae - pervert, deviant",
      "target_type": "individual"
    },
    {
      "word": "불알",
      "severity": 3,
      "categories": [
        "sexual",
        "scatological"
      ],
      "variations": [
        "불알",
        "bul-al",
        "불알"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 불알, Romanization: bul-al - testicles, vulgar",
      "target_type": "general"
    },
    {
      "word": "비열한",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "비열한",
        "biyeolhan"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 비열한, Romanization: biyeolhan - despicable, vile",
      "target_type": "individual"
    },
    {
      "word": "빠구리",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "빠구리",
        "ppaguri"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 빠구리, Romanization: ppaguri - sexual intercourse (vulgar)",
      "target_type": "general"
    },
    {
      "word": "빌어먹을",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "빌어먹을",
        "bileomeogeul"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 빌어먹을, Romanization: bileomeogeul - damned, cursed",
      "target_type": "general"
    },
    {
      "word": "창녀",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "창녀",
        "changnyeo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 창녀, Romanization: changnyeo - prostitute, whore (variant of 창년)",
      "target_type": "individual"
    },
    {
      "word": "쳐죽일놈",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "쳐죽일놈",
        "cheojugilnom"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 쳐죽일놈, Romanization: cheojugilnom - 'should be beaten to death'",
      "target_type": "individual"
    },
    {
      "word": "닥쳐라",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "닥쳐라",
        "dakchyeora"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 닥쳐라, Romanization: dakchyeora - shut up (stronger than 닥쳐)",
      "target_type": "individual"
    },
    {
      "word": "대가리",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "대가리",
        "daegari"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 대가리, Romanization: daegari - head (vulgar), 'noggin'",
      "target_type": "general"
    },
    {
      "word": "덜떨어진",
      "severity": 2,
      "categories": [
        "insult",
        "ableist"
      ],
      "variations": [
        "덜떨어진",
        "deolddeoleojin"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 덜떨어진, Romanization: deolddeoleojin - stupid, 'not all there'",
      "target_type": "individual"
    },
    {
      "word": "도둑놈",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "도둑놈",
        "doduknom"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 도둑놈, Romanization: doduknom - thief (insulting)",
      "target_type": "individual"
    },
    {
      "word": "돌대가리",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "돌대가리",
        "doldaegari"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 돌대가리, Romanization: doldaegari - stone head, very stupid",
      "target_type": "individual"
    },
    {
      "word": "똥개",
      "severity": 2,
      "categories": [
        "scatological",
        "insult"
      ],
      "variations": [
        "똥개",
        "ttonggae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 똥개, Romanization: ttonggae - shit dog",
      "target_type": "individual"
    },
    {
      "word": "뒤질래",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "뒤질래",
        "dwijillae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 뒤질래, Romanization: dwijillae - wanna die?",
      "target_type": "individual"
    },
    {
      "word": "뒤지다",
      "severity": 4,
      "categories": [
        "violence"
      ],
      "variations": [
        "뒤지다",
        "dwijida",
        "뒤져"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 뒤지다, Romanization: dwijida - to die (vulgar)",
      "target_type": "individual"
    },
    {
      "word": "염병",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "염병",
        "yeombyeong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 염병, Romanization: yeombyeong - plague, damn it",
      "target_type": "general"
    },
    {
      "word": "옘병",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "옘병",
        "yaembyeong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 옘병, Romanization: yaembyeong - variant of yeombyeong",
      "target_type": "general"
    },
    {
      "word": "개",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "개",
        "gae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 개, Romanization: gae - dog (prefix for intensification)",
      "target_type": "general"
    },
    {
      "word": "개같은",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "개같은",
        "gaegateun"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 개같은, Romanization: gaegateun - dog-like, shitty",
      "target_type": "general"
    },
    {
      "word": "개년",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "개년",
        "gaenyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 개년, Romanization: gaenyeon - bitch (female dog)",
      "target_type": "individual"
    },
    {
      "word": "개자식",
      "severity": 3,
      "categories": [
        "insult",
        "family_honor"
      ],
      "variations": [
        "개자식",
        "gaejasik"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 개자식, Romanization: gaejasik - son of a bitch",
      "target_type": "individual"
    },
    {
      "word": "개좆",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "개좆",
        "gaejot"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 개좆, Romanization: gaejot - dog dick",
      "target_type": "general"
    },
    {
      "word": "개차반",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "개차반",
        "gaechabaan"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 개차반, Romanization: gaechabaan - fucking mess",
      "target_type": "general"
    },
    {
      "word": "걸레",
      "severity": 3,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "걸레",
        "geolle"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 걸레, Romanization: geolle - rag, slut",
      "target_type": "individual"
    },
    {
      "word": "걸레같은년",
      "severity": 3,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "걸레같은년",
        "geolle gateun nyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 걸레같은년, Romanization: geolle gateun nyeon - trashy woman",
      "target_type": "individual"
    },
    {
      "word": "거지같은",
      "severity": 2,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "거지같은",
        "geojigateun"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 거지같은, Romanization: geojigateun - beggar-like, pathetic",
      "target_type": "individual"
    },
    {
      "word": "고자",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "고자",
        "goja"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 고자, Romanization: goja - eunuch, impotent (insult)",
      "target_type": "individual"
    },
    {
      "word": "꺼지라",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "꺼지라",
        "kkeojira"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 꺼지라, Romanization: kkeojira - get lost (command, stronger than 꺼져)",
      "target_type": "individual"
    },
    {
      "word": "꼬라지",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "꼬라지",
        "kkoraji"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 꼬라지, Romanization: kkoraji - pathetic appearance",
      "target_type": "individual"
    },
    {
      "word": "꼴값",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "꼴값",
        "kkolgap"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 꼴값, Romanization: kkolgap - acting one's pathetic status",
      "target_type": "individual"
    },
    {
      "word": "한남충",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "한남충",
        "hannamchoong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 한남충, Romanization: hannamchoong - Korean man bug",
      "target_type": "group"
    },
    {
      "word": "호구",
      "severity": 1,
      "categories": [
        "insult"
      ],
      "variations": [
        "호구",
        "hogu"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 호구, Romanization: hogu - sucker, fool",
      "target_type": "individual"
    },
    {
      "word": "호로",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "호로",
        "horo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 호로, Romanization: horo - prostitute",
      "target_type": "individual"
    },
    {
      "word": "호로새끼",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "호로새끼",
        "horosaekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 호로새끼, Romanization: horosaekki - son of a whore",
      "target_type": "individual"
    },
    {
      "word": "화냥년",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "화냥년",
        "hwanyangnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 화냥년, Romanization: hwanyangnyeon - promiscuous woman",
      "target_type": "individual"
    },
    {
      "word": "후레아들",
      "severity": 3,
      "categories": [
        "insult",
        "family_honor"
      ],
      "variations": [
        "후레아들",
        "hureadeul"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 후레아들, Romanization: hureadeul - son of a bitch",
      "target_type": "individual"
    },
    {
      "word": "후레자식",
      "severity": 3,
      "categories": [
        "insult",
        "family_honor"
      ],
      "variations": [
        "후레자식",
        "hurejasik"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 후레자식, Romanization: hurejasik - bastard child",
      "target_type": "individual"
    },
    {
      "word": "후장",
      "severity": 3,
      "categories": [
        "sexual",
        "scatological"
      ],
      "variations": [
        "후장",
        "hujang"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 후장, Romanization: hujang - anus (vulgar)",
      "target_type": "general"
    },
    {
      "word": "희쭈그리",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "희쭈그리",
        "huijjugeuri"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 희쭈그리, Romanization: huijjugeuri - vagina (regional slang)",
      "target_type": "general"
    },
    {
      "word": "잡년",
      "severity": 3,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "잡년",
        "jabyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 잡년, Romanization: jabyeon - bitch, slut",
      "target_type": "individual"
    },
    {
      "word": "재수없어",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "재수없어",
        "jaesu-eopseo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 재수없어, Romanization: jaesu-eopseo - unlucky, annoying person",
      "target_type": "individual"
    },
    {
      "word": "저능아",
      "severity": 3,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "저능아",
        "jeoneonga"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 저능아, Romanization: jeoneonga - low intelligence (ableist)",
      "target_type": "individual"
    },
    {
      "word": "젠장",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "젠장",
        "jenjang"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 젠장, Romanization: jenjang - damn it, shit",
      "target_type": "general"
    },
    {
      "word": "제정신이야",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "제정신이야",
        "jejeongsiniya"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 제정신이야, Romanization: jejeongsiniya - are you crazy?",
      "target_type": "individual"
    },
    {
      "word": "조센징",
      "severity": 4,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "조센징",
        "josenjing"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 조센징, Romanization: josenjing - variant of josenjin, Japanese colonial slur for Koreans",
      "target_type": "group"
    },
    {
      "word": "좆같은",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "좆같은",
        "jotgateun"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 좆같은, Romanization: jotgateun - fucking, dick-like (duplicate removed)",
      "target_type": "general"
    },
    {
      "word": "좆까",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "좆까",
        "jotka"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 좆까, Romanization: jotka - don't give a fuck",
      "target_type": "general"
    },
    {
      "word": "좆만한",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "좆만한",
        "jotmanhan"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 좆만한, Romanization: jotmanhan - dick-sized, tiny",
      "target_type": "individual"
    },
    {
      "word": "좆되다",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "좆되다",
        "jotdoeda"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 좆되다, Romanization: jotdoeda - to be fucked, screwed",
      "target_type": "general"
    },
    {
      "word": "좆됐어",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "좆됐어",
        "jotdwaesseo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 좆됐어, Romanization: jotdwaesseo - I'm fucked",
      "target_type": "general"
    },
    {
      "word": "졸라",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "졸라",
        "jolla"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 졸라, Romanization: jolla - variant of jonna",
      "target_type": "general"
    },
    {
      "word": "종간나",
      "severity": 4,
      "categories": [
        "hate_speech",
        "racial"
      ],
      "variations": [
        "종간나",
        "jongganna"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 종간나, Romanization: jongganna - mixed race (offensive)",
      "target_type": "individual"
    },
    {
      "word": "좌파빨갱이",
      "severity": 3,
      "categories": [
        "hate_speech",
        "political"
      ],
      "variations": [
        "좌파빨갱이",
        "jwapappalgaengi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 좌파빨갱이, Romanization: jwapappalgaengi - left-wing red",
      "target_type": "group"
    },
    {
      "word": "죽어라",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "죽어라",
        "jugeora"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 죽어라, Romanization: jugeora - die (stronger command)",
      "target_type": "individual"
    },
    {
      "word": "죽을래",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "죽을래",
        "jugeullae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 죽을래, Romanization: jugeullae - wanna die?",
      "target_type": "individual"
    },
    {
      "word": "죽일년",
      "severity": 4,
      "categories": [
        "violence",
        "threats",
        "hate_speech"
      ],
      "variations": [
        "죽일년",
        "jugilnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 죽일년, Romanization: jugilnyeon - woman who should die",
      "target_type": "individual"
    },
    {
      "word": "쥐좆",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "쥐좆",
        "jwijot"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 쥐좆, Romanization: jwijot - mouse dick, tiny dick",
      "target_type": "individual"
    },
    {
      "word": "김치남",
      "severity": 2,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "김치남",
        "gimchinam"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 김치남, Romanization: gimchinam - kimchi man",
      "target_type": "group"
    },
    {
      "word": "망할",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "망할",
        "manghal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 망할, Romanization: manghal - damned, cursed",
      "target_type": "general"
    },
    {
      "word": "먹튀",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "먹튀",
        "meoktwi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 먹튀, Romanization: meoktwi - eat and run, scammer",
      "target_type": "individual"
    },
    {
      "word": "멍청한",
      "severity": 1,
      "categories": [
        "insult"
      ],
      "variations": [
        "멍청한",
        "meongcheonghan"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 멍청한, Romanization: meongcheonghan - stupid",
      "target_type": "individual"
    },
    {
      "word": "몰카",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "몰카",
        "molka"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 몰카, Romanization: molka - hidden camera, spy cam",
      "target_type": "general"
    },
    {
      "word": "미친놈",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "미친놈",
        "michinnom"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 미친놈, Romanization: michinnom - crazy bastard (male)",
      "target_type": "individual"
    },
    {
      "word": "미친년",
      "severity": 2,
      "categories": [
        "insult",
        "hate_speech"
      ],
      "variations": [
        "미친년",
        "michinnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 미친년, Romanization: michinnyeon - crazy bitch (female)",
      "target_type": "individual"
    },
    {
      "word": "미친새끼",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "미친새끼",
        "michinsaekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 미친새끼, Romanization: michinsaekki - crazy son of a bitch",
      "target_type": "individual"
    },
    {
      "word": "미친개",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "미친개",
        "michingae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 미친개, Romanization: michingae - crazy dog",
      "target_type": "individual"
    },
    {
      "word": "미쳤어",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "미쳤어",
        "michyeosseo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 미쳤어, Romanization: michyeosseo - are you crazy?",
      "target_type": "individual"
    },
    {
      "word": "미쳤어요",
      "severity": 1,
      "categories": [
        "insult"
      ],
      "variations": [
        "미쳤어요",
        "michyeosseoyo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 미쳤어요, Romanization: michyeosseoyo - are you crazy? (polite)",
      "target_type": "individual"
    },
    {
      "word": "남창",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "남창",
        "namchang"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 남창, Romanization: namchang - male prostitute",
      "target_type": "individual"
    },
    {
      "word": "냄져",
      "severity": 2,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "냄져",
        "naemjyeo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 냄져, Romanization: naemjyeo - man (derogatory spelling)",
      "target_type": "group"
    },
    {
      "word": "넌씨눈",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "넌씨눈",
        "neonssinun"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 넌씨눈, Romanization: neonssinun - stink eye, dirty look",
      "target_type": "individual"
    },
    {
      "word": "년",
      "severity": 2,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "년",
        "nyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 년, Romanization: nyeon - bitch, year (derogatory for women)",
      "target_type": "individual"
    },
    {
      "word": "노망",
      "severity": 2,
      "categories": [
        "insult",
        "ableist"
      ],
      "variations": [
        "노망",
        "nomang"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 노망, Romanization: nomang - senile, demented",
      "target_type": "individual"
    },
    {
      "word": "노예",
      "severity": 2,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "노예",
        "noye"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 노예, Romanization: noye - slave (insulting context)",
      "target_type": "individual"
    },
    {
      "word": "로리타",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "로리타",
        "lorita"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 로리타, Romanization: lorita - lolita, pedophilic reference",
      "target_type": "general"
    },
    {
      "word": "사까시",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "사까시",
        "sakasi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 사까시, Romanization: sakasi - fellatio (vulgar)",
      "target_type": "general"
    },
    {
      "word": "섹스",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "섹스",
        "sekseu"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 섹스, Romanization: sekseu - sex (can be vulgar in context)",
      "target_type": "general"
    },
    {
      "word": "세끼",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "세끼",
        "sekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 세끼, Romanization: sekki - variant of saekki",
      "target_type": "individual"
    },
    {
      "word": "소인배",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "소인배",
        "soinbae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 소인배, Romanization: soinbae - petty person",
      "target_type": "individual"
    },
    {
      "word": "쌍년",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "쌍년",
        "ssangnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 쌍년, Romanization: ssangnyeon - double bitch",
      "target_type": "individual"
    },
    {
      "word": "쌍놈",
      "severity": 3,
      "categories": [
        "insult"
      ],
      "variations": [
        "쌍놈",
        "ssangnom"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 쌍놈, Romanization: ssangnom - double bastard",
      "target_type": "individual"
    },
    {
      "word": "쌍욕",
      "severity": 3,
      "categories": [
        "general"
      ],
      "variations": [
        "쌍욕",
        "ssangyok"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 쌍욕, Romanization: ssangyok - double curse",
      "target_type": "general"
    },
    {
      "word": "씨발놈",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씨발놈",
        "ssibalnom",
        "ㅅㅂㄹㅁ"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씨발놈, Romanization: ssibalnom - fucking bastard",
      "target_type": "individual"
    },
    {
      "word": "씨발년",
      "severity": 3,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "씨발년",
        "ssibalnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씨발년, Romanization: ssibalnyeon - fucking bitch",
      "target_type": "individual"
    },
    {
      "word": "씨팔",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씨팔",
        "ssipal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씨팔, Romanization: ssipal - variant of ssibal",
      "target_type": "general"
    },
    {
      "word": "씁새끼",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씁새끼",
        "ssipsaekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씁새끼, Romanization: ssipsaekki - fucking bastard",
      "target_type": "individual"
    },
    {
      "word": "씹",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹",
        "ssip"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹, Romanization: ssip - fuck (abbreviated)",
      "target_type": "general"
    },
    {
      "word": "씹새끼",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹새끼",
        "ssipsaekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹새끼, Romanization: ssipsaekki - fucking bastard (duplicate)",
      "target_type": "individual"
    },
    {
      "word": "씹물",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹물",
        "ssipmul"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹물, Romanization: ssipmul - pussy juice (vulgar)",
      "target_type": "general"
    },
    {
      "word": "씹빨",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹빨",
        "ssippal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹빨, Romanization: ssippal - pussy sucker",
      "target_type": "individual"
    },
    {
      "word": "씹알",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹알",
        "ssipal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹알, Romanization: ssipal - fuck off",
      "target_type": "general"
    },
    {
      "word": "씹창",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹창",
        "ssipchang"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹창, Romanization: ssipchang - fucking disaster",
      "target_type": "general"
    },
    {
      "word": "씹팔",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹팔",
        "ssippal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹팔, Romanization: ssippal - variant of ssibal",
      "target_type": "general"
    },
    {
      "word": "씹할",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "씹할",
        "ssiphal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹할, Romanization: ssiphal - fuck",
      "target_type": "general"
    },
    {
      "word": "또라이",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "또라이",
        "ttorrai"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 또라이, Romanization: ttorrai - nutjob, crazy person",
      "target_type": "individual"
    },
    {
      "word": "야동",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "야동",
        "yadong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 야동, Romanization: yadong - adult video, porn",
      "target_type": "general"
    },
    {
      "word": "야사",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "야사",
        "yasa"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 야사, Romanization: yasa - pornographic story",
      "target_type": "general"
    },
    {
      "word": "야애니",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "야애니",
        "yaaeni"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 야애니, Romanization: yaaeni - hentai, adult anime",
      "target_type": "general"
    },
    {
      "word": "양아치",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "양아치",
        "yangachi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 양아치, Romanization: yangachi - thug, hooligan",
      "target_type": "individual"
    },
    {
      "word": "어중이떠중이",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "어중이떠중이",
        "eojungitteojungi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 어중이떠중이, Romanization: eojungitteojungi - riffraff",
      "target_type": "group"
    },
    {
      "word": "얼간이",
      "severity": 1,
      "categories": [
        "insult"
      ],
      "variations": [
        "얼간이",
        "eolgani"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 얼간이, Romanization: eolgani - fool, simpleton",
      "target_type": "individual"
    },
    {
      "word": "엄창",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual"
      ],
      "variations": [
        "엄창",
        "eomchang"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 엄창, Romanization: eomchang - mother whore, attacks family honor",
      "target_type": "family"
    },
    {
      "word": "에로",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "에로",
        "ero"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 에로, Romanization: ero - erotic (can be vulgar)",
      "target_type": "general"
    },
    {
      "word": "염병할",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "염병할",
        "yeombyeonghal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 염병할, Romanization: yeombyeonghal - goddamn",
      "target_type": "general"
    },
    {
      "word": "옘병할",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "옘병할",
        "yaembyeonghal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 옘병할, Romanization: yaembyeonghal - variant of yeombyeonghal",
      "target_type": "general"
    },
    {
      "word": "오랑캐",
      "severity": 3,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "오랑캐",
        "orangkae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 오랑캐, Romanization: orangkae - barbarian (ethnic slur)",
      "target_type": "group"
    },
    {
      "word": "왕따",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "왕따",
        "wangtta"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 왕따, Romanization: wangtta - outcast, bullied person",
      "target_type": "individual"
    },
    {
      "word": "외퀴",
      "severity": 3,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "외퀴",
        "oekwi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 외퀴, Romanization: oekwi - one-eyed (ableist)",
      "target_type": "individual"
    },
    {
      "word": "유모",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "유모",
        "yumo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 유모, Romanization: yumo - wet nurse (can be sexual slang)",
      "target_type": "general"
    },
    {
      "word": "육갑",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "육갑",
        "yukgap"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 육갑, Romanization: yukgap - bullshit, nonsense",
      "target_type": "general"
    },
    {
      "word": "은꼴",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "은꼴",
        "eunkkol"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 은꼴, Romanization: eunkkol - masturbation material",
      "target_type": "general"
    },
    {
      "word": "자살해",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "자살해",
        "jasalhae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 자살해, Romanization: jasalhae - go kill yourself",
      "target_type": "individual"
    },
    {
      "word": "장애인",
      "severity": 2,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "장애인",
        "jangaein"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 장애인, Romanization: jangaein - disabled person (offensive in context)",
      "target_type": "individual"
    },
    {
      "word": "저능",
      "severity": 3,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "저능",
        "jeoneung"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 저능, Romanization: jeoneung - low intelligence (ableist)",
      "target_type": "individual"
    },
    {
      "word": "정신병자",
      "severity": 3,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "정신병자",
        "jeongsinbyeongja"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 정신병자, Romanization: jeongsinbyeongja - mentally ill person (ableist)",
      "target_type": "individual"
    },
    {
      "word": "정신나갔어",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "정신나갔어",
        "jeongsinagasseo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 정신나갔어, Romanization: jeongsinagasseo - you've lost your mind",
      "target_type": "individual"
    },
    {
      "word": "제기랄",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "제기랄",
        "jegiral"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 제기랄, Romanization: jegiral - damn it, shit",
      "target_type": "general"
    },
    {
      "word": "조까",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "조까",
        "jokka"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 조까, Romanization: jokka - fuck it",
      "target_type": "general"
    },
    {
      "word": "조질래",
      "severity": 3,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "조질래",
        "jojillae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 조질래, Romanization: jojillae - wanna get beaten?",
      "target_type": "individual"
    },
    {
      "word": "존만한",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "존만한",
        "jonmanhan"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 존만한, Romanization: jonmanhan - dick-sized (insult)",
      "target_type": "individual"
    },
    {
      "word": "ㄱㅅ",
      "severity": 2,
      "categories": [
        "internet_gaming"
      ],
      "variations": [
        "ㄱㅅ",
        "gs",
        "개소리"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: ㄱㅅ, Romanization: gs - abbreviation for 개소리 (gaesori) - bullshit",
      "target_type": "general"
    },
    {
      "word": "ㅂㄷㅂㄷ",
      "severity": 2,
      "categories": [
        "internet_gaming"
      ],
      "variations": [
        "ㅂㄷㅂㄷ",
        "bdbd",
        "부들부들"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: ㅂㄷㅂㄷ, Romanization: bdbd - 부들부들 (budeulbudeul) - trembling with anger",
      "target_type": "general"
    },
    {
      "word": "ㅆㅂ",
      "severity": 3,
      "categories": [
        "internet_gaming",
        "sexual"
      ],
      "variations": [
        "ㅆㅂ",
        "ssb",
        "씨발"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: ㅆㅂ, Romanization: ssb - abbreviation for 씨발 (ssibal) - fuck",
      "target_type": "general"
    },
    {
      "word": "ㅈ",
      "severity": 3,
      "categories": [
        "internet_gaming",
        "sexual"
      ],
      "variations": [
        "ㅈ",
        "j",
        "좆"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: ㅈ, Romanization: j - abbreviation for 좆 (jot) - dick",
      "target_type": "general"
    },
    {
      "word": "ㅉㅉ",
      "severity": 1,
      "categories": [
        "internet_gaming"
      ],
      "variations": [
        "ㅉㅉ",
        "jjjj",
        "쯧쯧"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: ㅉㅉ, Romanization: jjjj - 쯧쯧 (jjeujjeu) - tsk tsk (disapproval)",
      "target_type": "general"
    },
    {
      "word": "ㅊㅊ",
      "severity": 1,
      "categories": [
        "internet_gaming"
      ],
      "variations": [
        "ㅊㅊ",
        "cc"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: ㅊㅊ, Romanization: cc - 축하 (chukha) but can mean 처치 (cheochi) - get rid of",
      "target_type": "general"
    },
    {
      "word": "ㅍㅌㅊ",
      "severity": 1,
      "categories": [
        "internet_gaming"
      ],
      "variations": [
        "ㅍㅌㅊ",
        "ptc",
        "파이팅"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: ㅍㅌㅊ, Romanization: ptc - 파이팅 (paiting) - fighting (but used sarcastically)",
      "target_type": "general"
    },
    {
      "word": "강간",
      "severity": 4,
      "categories": [
        "sexual",
        "violence"
      ],
      "variations": [
        "강간",
        "ganggan"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 강간, Romanization: ganggan - rape",
      "target_type": "general"
    },
    {
      "word": "거유",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "거유",
        "geoyu"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 거유, Romanization: geoyu - big breasts",
      "target_type": "general"
    },
    {
      "word": "계집",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "계집",
        "gyejip"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 계집, Romanization: gyejip - woman (archaic, derogatory)",
      "target_type": "individual"
    },
    {
      "word": "계집년",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "계집년",
        "gyejipnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 계집년, Romanization: gyejipnyeon - bitch",
      "target_type": "individual"
    },
    {
      "word": "근친",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "근친",
        "geunchin"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 근친, Romanization: geunchin - incest",
      "target_type": "general"
    },
    {
      "word": "노모",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "노모",
        "nomo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 노모, Romanization: nomo - exposed/uncensored (porn term)",
      "target_type": "general"
    },
    {
      "word": "딸딸이",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "딸딸이",
        "ttalttari"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 딸딸이, Romanization: ttalttari - masturbation",
      "target_type": "general"
    },
    {
      "word": "딸치다",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "딸치다",
        "ttalchida"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 딸치다, Romanization: ttalchida - to masturbate",
      "target_type": "general"
    },
    {
      "word": "따먹다",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "따먹다",
        "ttameokda"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 따먹다, Romanization: ttameokda - to fuck (vulgar)",
      "target_type": "general"
    },
    {
      "word": "망가",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "망가",
        "manga"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 망가, Romanization: manga - manga (porn context)",
      "target_type": "general"
    },
    {
      "word": "몸매",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "몸매",
        "mommae"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 몸매, Romanization: mommae - body figure (can be objectifying)",
      "target_type": "general"
    },
    {
      "word": "바바리맨",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "바바리맨",
        "babarimen"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 바바리맨, Romanization: babarimen - flasher, exhibitionist",
      "target_type": "individual"
    },
    {
      "word": "발기",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "발기",
        "balgi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 발기, Romanization: balgi - erection",
      "target_type": "general"
    },
    {
      "word": "보짓물",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "보짓물",
        "bojitmul"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 보짓물, Romanization: bojitmul - vaginal fluid (extremely vulgar)",
      "target_type": "general"
    },
    {
      "word": "빨다",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "빨다",
        "ppalda"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 빨다, Romanization: ppalda - to suck (sexual)",
      "target_type": "general"
    },
    {
      "word": "빨아주다",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "빨아주다",
        "pparajuda"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 빨아주다, Romanization: pparajuda - to give head",
      "target_type": "general"
    },
    {
      "word": "사정",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "사정",
        "sajeong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 사정, Romanization: sajeong - ejaculation",
      "target_type": "general"
    },
    {
      "word": "섹파",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "섹파",
        "sekpa"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 섹파, Romanization: sekpa - sex partner",
      "target_type": "general"
    },
    {
      "word": "스와핑",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "스와핑",
        "seuwaping"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 스와핑, Romanization: seuwaping - swapping (partner swapping)",
      "target_type": "general"
    },
    {
      "word": "씹년",
      "severity": 3,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "씹년",
        "ssipnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 씹년, Romanization: ssipnyeon - fucking bitch",
      "target_type": "individual"
    },
    {
      "word": "애무",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "애무",
        "aemu"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 애무, Romanization: aemu - caress (sexual)",
      "target_type": "general"
    },
    {
      "word": "오르가즘",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "오르가즘",
        "oreugazeum"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 오르가즘, Romanization: oreugazeum - orgasm",
      "target_type": "general"
    },
    {
      "word": "유두",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "유두",
        "yudu"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 유두, Romanization: yudu - nipple",
      "target_type": "general"
    },
    {
      "word": "음경",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "음경",
        "eumgyeong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 음경, Romanization: eumgyeong - penis (clinical but vulgar in casual use)",
      "target_type": "general"
    },
    {
      "word": "음모",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "음모",
        "eumo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 음모, Romanization: eumo - pubic hair",
      "target_type": "general"
    },
    {
      "word": "자위",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "자위",
        "jawi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 자위, Romanization: jawi - masturbation",
      "target_type": "general"
    },
    {
      "word": "자위행위",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "자위행위",
        "jawihengwi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 자위행위, Romanization: jawihengwi - act of masturbation",
      "target_type": "general"
    },
    {
      "word": "정액",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "정액",
        "jeongaek"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 정액, Romanization: jeongaek - semen",
      "target_type": "general"
    },
    {
      "word": "직촬",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "직촬",
        "jikchwal"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 직촬, Romanization: jikchwal - direct filming (upskirt, spy cam)",
      "target_type": "general"
    },
    {
      "word": "질",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "질",
        "jil"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 질, Romanization: jil - vagina",
      "target_type": "general"
    },
    {
      "word": "처녀",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "처녀",
        "cheonyeo"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 처녀, Romanization: cheonyeo - virgin (female, can be offensive)",
      "target_type": "individual"
    },
    {
      "word": "처먹다",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "처먹다",
        "cheomeokda"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 처먹다, Romanization: cheomeokda - to fuck (eat in vulgar sense)",
      "target_type": "general"
    },
    {
      "word": "콘돔",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "콘돔",
        "kondom"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 콘돔, Romanization: kondom - condom",
      "target_type": "general"
    },
    {
      "word": "클리토리스",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "클리토리스",
        "keullitoriseu"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 클리토리스, Romanization: keullitoriseu - clitoris",
      "target_type": "general"
    },
    {
      "word": "타락",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "타락",
        "tarak"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 타락, Romanization: tarak - corruption, debauchery",
      "target_type": "general"
    },
    {
      "word": "포르노",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "포르노",
        "poreuno"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 포르노, Romanization: poreuno - pornography",
      "target_type": "general"
    },
    {
      "word": "하드코어",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "하드코어",
        "hadeukoa"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 하드코어, Romanization: hadeukoa - hardcore (porn)",
      "target_type": "general"
    },
    {
      "word": "항문",
      "severity": 2,
      "categories": [
        "sexual",
        "scatological"
      ],
      "variations": [
        "항문",
        "hangmun"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 항문, Romanization: hangmun - anus",
      "target_type": "general"
    },
    {
      "word": "니기미",
      "severity": 4,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "니기미",
        "nigimi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 니기미, Romanization: nigimi - your mother (regional curse)",
      "target_type": "family"
    },
    {
      "word": "시부랄",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "시부랄",
        "sibural"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 시부랄, Romanization: sibural - fuck (dialectal variant)",
      "target_type": "general"
    },
    {
      "word": "엠병",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "엠병",
        "embyeong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 엠병, Romanization: embyeong - damn (dialect)",
      "target_type": "general"
    },
    {
      "word": "이눔아",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "이눔아",
        "inuma"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 이눔아, Romanization: inuma - you bastard (traditional)",
      "target_type": "individual"
    },
    {
      "word": "이새끼",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "이새끼",
        "isaekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 이새끼, Romanization: isaekki - this bastard",
      "target_type": "individual"
    },
    {
      "word": "저새끼",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "저새끼",
        "jeosaekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 저새끼, Romanization: jeosaekki - that bastard",
      "target_type": "individual"
    },
    {
      "word": "니미",
      "severity": 4,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "니미",
        "nimi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 니미, Romanization: nimi - your mother (shortened)",
      "target_type": "family"
    },
    {
      "word": "니미럴",
      "severity": 4,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "니미럴",
        "nimirol"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 니미럴, Romanization: nimirol - your mother (variant)",
      "target_type": "family"
    },
    {
      "word": "뒤질",
      "severity": 4,
      "categories": [
        "violence"
      ],
      "variations": [
        "뒤질",
        "dwijil"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 뒤질, Romanization: dwijil - die (dialectal)",
      "target_type": "individual"
    },
    {
      "word": "때씹",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "때씹",
        "ttaessip"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 때씹, Romanization: ttaessip - fuck (regional)",
      "target_type": "general"
    },
    {
      "word": "때끼",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "때끼",
        "ttaekki"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 때끼, Romanization: ttaekki - bastard (regional)",
      "target_type": "individual"
    },
    {
      "word": "망할년",
      "severity": 3,
      "categories": [
        "hate_speech",
        "gender"
      ],
      "variations": [
        "망할년",
        "manghalnyeon"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 망할년, Romanization: manghalnyeon - damned woman",
      "target_type": "individual"
    },
    {
      "word": "뙤놈",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "뙤놈",
        "dwaenom"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 뙤놈, Romanization: dwaenom - damn bastard (dialect)",
      "target_type": "individual"
    },
    {
      "word": "시부렁",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "시부렁",
        "siburong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 시부렁, Romanization: siburong - muttering curses",
      "target_type": "general"
    },
    {
      "word": "육시랄",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "육시랄",
        "yuksiral"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 육시랄, Romanization: yuksiral - damn it all",
      "target_type": "general"
    },
    {
      "word": "이그",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "이그",
        "igeu"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 이그, Romanization: igeu - ugh (mild curse)",
      "target_type": "general"
    },
    {
      "word": "개만도못한",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "개만도못한",
        "gaemando mothan"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 개만도못한, Romanization: gaemando mothan - worse than a dog",
      "target_type": "individual"
    },
    {
      "word": "지옥에가",
      "severity": 3,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "지옥에가",
        "jiogega"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 지옥에가, Romanization: jiogega - go to hell",
      "target_type": "individual"
    },
    {
      "word": "썩을",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "썩을",
        "sseogeul"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 썩을, Romanization: sseogeul - rotten, damned",
      "target_type": "general"
    },
    {
      "word": "미친광이",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "미친광이",
        "michingwangi"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 미친광이, Romanization: michingwangi - crazy fool",
      "target_type": "individual"
    },
    {
      "word": "정신병",
      "severity": 3,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "정신병",
        "jeongsinbyeong"
      ],
      "case_sensitive": false,
      "context_notes": "Hangul: 정신병, Romanization: jeongsinbyeong - mental illness (used as insult)",
      "target_type": "individual"
    }
  ]
} as const

export type KOType = typeof KO
